import { render, staticRenderFns } from "./MyServicesBurgerMenu.vue?vue&type=template&id=4cbb624c&scoped=true&"
import script from "./MyServicesBurgerMenu.vue?vue&type=script&lang=js&"
export * from "./MyServicesBurgerMenu.vue?vue&type=script&lang=js&"
import style0 from "./MyServicesBurgerMenu.vue?vue&type=style&index=0&id=4cbb624c&prod&scoped=true&lang=css&"
import style1 from "./MyServicesBurgerMenu.vue?vue&type=style&index=1&id=4cbb624c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbb624c",
  null
  
)

export default component.exports